import React from 'react';

interface PayoutTokenCellProps {
  logo?: string;
  symbol?: string;
  percent: number;
}

export default function PayoutTokenCell({ logo, symbol, percent }: PayoutTokenCellProps ) {

  const percentCssStyle = {
    '--percent-width': `${percent}%`
  } as React.CSSProperties;

  return (
  <span className="table__row-icon payout-token-cell">
    <img src={logo} alt={symbol} />
    <div>
      {symbol}
      <div className="payout-token-cell__percent-container">
        <hr
          className="payout-token-cell__bar"
          style={percentCssStyle}
        />
        <span className="payout-token-cell__percent">
          {percent}% sold
        </span>
      </div>
    </div>
  </span>
  )
}
